import { createFileRoute, redirect } from '@tanstack/react-router';
import * as R from 'remeda';
import * as appActions from 'store/glue/app/actions';
import { bearerToken } from 'store/glue/user/selectors';
import { waitForLoading } from 'store/helpers';
import { NavigationRoute } from 'templates';
import { getType } from 'typesafe-actions';

export const Route = createFileRoute('/_authenticated')({
  // Auth guard: unauthenticated users are redirected to /login.
  // Runs synchronously before any child route renders. We attach the original
  // href as `?redirect=...` so /login (and the OIDC roundtrip) can navigate
  // the user back to where they were trying to go after auth completes.
  beforeLoad: ({ context: { store }, location }) => {
    const token = bearerToken(store.getState());
    if (!R.isDefined(token)) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
        replace: true,
      });
    }
  },
  // Kick off global data init and block navigation until it completes.
  // The initial Redux state for START_INITIALIZE is 'loading' (the "not yet
  // initialized" sentinel), so the Promise waits for the saga to clear it.
  // staleTime: Infinity means this only runs once per session.
  loader: async ({ context: { store } }) => {
    store.dispatch(appActions.startInitialize());
    await waitForLoading(store, getType(appActions.startInitialize));
  },
  staleTime: Infinity,
  // NavigationRoute renders <AppBar /> + <Outlet /> — it is the authenticated layout shell
  component: NavigationRoute,
});
